export const isBrowser = true;
export const isNode = false;

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
